import { useSelector } from 'react-redux';

import { useFeatureFlags } from 'ha/modules/FeatureFlags';
import { ListingPricingType } from '@ha/api/v2/types/Listing';
import { PricingStructure } from 'ha/modules/Pricing';
import { getPricingType } from '../../reducer';
import { useLocalPricing } from '../../hooks/useLocalPricing';

export const useAdvancedPricingCalendar = () => {
  const pricingType = useSelector(getPricingType);
  const { pricingStructure } = useLocalPricing();
  const { monthlyPricesCalendar } = useFeatureFlags();
  return (
    monthlyPricesCalendar === 'on' &&
    pricingStructure === PricingStructure.instalment &&
    pricingType === ListingPricingType.MONTHLY
  );
};
